<template>
  <router-link to="#" class="search-result-card">
    <span class="name"> {{ candidate.firstName }} </span>
    <!-- TODO: FJERN V-IF NÅR DATABASEN ER :THUMBSUP: -->
    <span v-if="candidate.module"> {{ candidate.module.name }} </span>
    <span> {{ candidate.city }} </span>
    <span> {{ candidate.canWorkFulltime }} </span>
  </router-link>
</template>

<script>
export default {
  name: "SearchResultCard",
  props: {
    candidate: {},
  },
};
</script>

<style lang="scss" scoped>
.search-result-card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-radius: var(--border-radius);
  padding: 2em 1em;
  margin-bottom: 1em;
  cursor: pointer;

  span {
    padding: 5px;
    width: 25%;
    flex-grow: 1;
    flex-basis: 0;

    &:first-child {
      width: 50%;
      font-weight: bold;
    }
  }
}
</style>